import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const pics = Loadable({
    loader: () => import(/* webpackChunkName: "pics" */ './pics'),
    loading: () => <div />,
});
